import { Form, Input } from 'antd';
const FormItem = Form.Item;
import React from 'react';

import { Ticket } from '@totem/components/ticketing/ticketing';

const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
  summaryInput: {
    width: '425px',
  },
};

type Props = {
  partyInvolvedIndex: number;
  partyInvolvedType: string;
  ticketData: Ticket;
  setTicketData: React.Dispatch<React.SetStateAction<Ticket>>;
};

const PartyInvolvedEntry = ({
  partyInvolvedIndex,
  ticketData,
  setTicketData,
}: Props) => {
  return (
    <>
      <FormItem label="Name" colon={false} style={styles.formItem}>
        <Input
          name="name"
          type="text"
          style={styles.summaryInput}
          value={ticketData.partiesInvolved[partyInvolvedIndex].name}
          onChange={(
            evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => {
            setTicketData((prevTicketData) => ({
              ...prevTicketData,
              partiesInvolved: prevTicketData.partiesInvolved.map(
                (party, index) => {
                  if (index === partyInvolvedIndex) {
                    return {
                      ...party,
                      name: evt.target.value,
                    };
                  }
                  return party;
                },
              ),
            }));
          }}
          maxLength={50}
        />
      </FormItem>
      <FormItem label="Email" colon={false} style={styles.formItem}>
        <Input
          name="email"
          type="text"
          style={styles.summaryInput}
          value={ticketData.partiesInvolved[partyInvolvedIndex].email}
          onChange={(
            evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => {
            setTicketData((prevTicketData) => ({
              ...prevTicketData,
              partiesInvolved: prevTicketData.partiesInvolved.map(
                (party, index) => {
                  if (index === partyInvolvedIndex) {
                    return {
                      ...party,
                      email: evt.target.value,
                    };
                  }
                  return party;
                },
              ),
            }));
          }}
          maxLength={50}
        />
      </FormItem>
      <FormItem label="Phone" colon={false} style={styles.formItem}>
        <Input
          name="phone"
          type="text"
          style={styles.summaryInput}
          value={ticketData.partiesInvolved[partyInvolvedIndex].phone}
          onChange={(
            evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => {
            setTicketData((prevTicketData) => ({
              ...prevTicketData,
              partiesInvolved: prevTicketData.partiesInvolved.map(
                (party, index) => {
                  if (index === partyInvolvedIndex) {
                    return {
                      ...party,
                      phone: evt.target.value,
                    };
                  }
                  return party;
                },
              ),
            }));
          }}
          maxLength={50}
        />
      </FormItem>
    </>
  );
};

export default PartyInvolvedEntry;
